import { PWF_ACTIVATION_STATUS } from "src/consts/accept-payment";
import { ALLOWED_KYC_STATUS_AP_FEATURES } from "../consts/setup";
import { KYC_STATUS } from "src/scenes/NewVerification/consts/kyc";

//
// All functions below are conditioned in a way to follow this document: https://docs.google.com/spreadsheets/d/1PwAyKEOkxYBYgp3iyK0hGFQROd-arS2L97uhEiXQVTw/edit#gid=1301171441
//

export function isKYCStatusAllowedToUseApFeatures(kycStatus) {
  return ALLOWED_KYC_STATUS_AP_FEATURES.includes(kycStatus);
}

/**
 * Activation states with no Accept Payment access beyond the Overview page.
 *
 * ACCEPTED sits here alongside NONE: the company has been accepted but self-serve
 * activation is closed, so it gets the same Overview-only treatment.
 */
export const PWF_STATUS_OVERVIEW_ONLY = [PWF_ACTIVATION_STATUS.NONE, PWF_ACTIVATION_STATUS.ACCEPTED];

export function isPwfStatusAllowedToSeeApMenus(pwfStatus) {
  return !PWF_STATUS_OVERVIEW_ONLY.includes(pwfStatus);
}

export function isAllowedToAccessApMenus({ kycStatus, pwfStatus }) {
  return isPwfStatusAllowedToSeeApMenus(pwfStatus) && isKYCStatusAllowedToUseApFeatures(kycStatus);
}

/**
 * Returns true if user can see Bill list in the Overview Table
 *
 * PWF Status must be ACTIVE and KYC status must be at least after Waiting for Approval.
 * KYB-rejected companies cannot see the table.
 */
export function isAllowedToAccessApOverviewTable({ kycStatus, pwfStatus }) {
  if (kycStatus === KYC_STATUS.REJECTED) return false;
  return pwfStatus === PWF_ACTIVATION_STATUS.ACTIVE && isKYCStatusAllowedToUseApFeatures(kycStatus);
}
